module.exports = {
  white: '#fff',
  black: '#000',
  grey50: '#fafafa',
  grey100: '#f5f5f5',
  grey200: '#eeeeee',
  grey300: '#e0e0e0',
  grey400: '#bdbdbd',
  grey500: '#9e9e9e',
  grey600: '#757575',
  grey700: '#616161',
  grey800: '#424242',
  grey900: '#212121',
  brandDark: '#247488',
  brand: '#3DB5D0',
  brandLight: '#bee6ef',
  brandLighter: '#f1fbfc',
  neutralDarkest: '#172b4e',
  neutralDarker: '#425a70',
  neutralDark: '#879ba6',
  neutral: '#d3dce6',
  neutralLight: '#eaeff4',
  neutralLighter: '#f8f9fa',
  backgroundColor: '#F1F5F9',
  azureDark: '#C2CDF4',
  azure: '#E0E7FF',
  azureLight: '#F9FAFF',
  redDark: '#BF0E08',
  red: '#EC4C47',
  redLight: '#F8C8C8',
  redLighter: '#fae2e2',
  danger: '#EC4C47',
  orangeDark: '#a16d22',
  orange: '#f8a00f',
  orangeLight: '#f9ebd6',
  orangeLighter: '#fff7eb',
  warning: '#f8a00f',
  blueDark: '#2A41A2',
  blue: '#3A78F2',
  blueLight: '#CFD8FF',
  blueLighter: '#E7EBFC',
  info: '#3A78F2',
  greenDark: '#288A70',
  green: '#3FBC9B',
  greenLight: '#C1E8DE',
  greenLighter: '#E7F5F1',
  success: '#3FBC9B',
  pinkDark: '#852785',
  pink: '#BB36BB',
  pinkLight: '#EFDAEF',
  pinkLighter: '#FEF3FE',
  purpleDark: '#643790',
  purple: '#8C46D1',
  purpleLight: '#E1CEF5',
  purpleLighter: '#F7F0FF',
  violetDark: '#3B2F7D',
  violet: '#5D4AC8',
  violetLight: '#D4CFF3',
  violetLighter: '#EFEDFF',
  yellowDark: '#B49424',
  yellow: '#FADB4A',
  yellowLight: '#FFF0AB',
  yellowLighter: '#FFF9DC',
  lighterOverlay: 'rgba(33, 33, 33, 0.05)',
  lightOverlay: 'rgba(33, 33, 33, 0.1)',
  darkOverlay: 'rgba(66, 90, 112, 0.9)',
  defaultBorderRadius: '4px',
  borderRadiusLarge: '8px',
  borderRadiusSmall: '2px',
  defaultFontSize: '14px',
  defaultFontFamily: '"Rubik", sans-serif',
  defaultLineHeight: '1.2',
  defaultLetterSpacing: '0.04em',
  colorPrimary: '#172b4e',
  colorPrimaryInverse: '#fff',
  colorSecondary: '#879ba6',
  colorSecondaryInverse: 'rgba(255, 255, 255, 0.7)',
  colorTertiary: 'rgba(135, 155, 166, 0.7)',
  colorTertiaryInverse: 'rgba(255, 255, 255, 0.5)',
  colorDisabled: 'rgba(135, 155, 166, 0.5)',
  colorDisabledInverse: 'rgba(255, 255, 255, 0.3)',
  shadowColor: 'rgba(135, 155, 166, 0.3)',
  elevation1: '0 2px 10px rgba(135, 155, 166, 0.1)',
  elevation2: '0 7px 14px rgba(135, 155, 166, 0.2)',
  elevation3: '0 10px 17px rgba(135, 155, 166, 0.3)',
  insetActive: '0 1px 6px #172b4e inset',
  insetActiveMedium: '0 1px 6px #879ba6 inset',
  insetActiveLight: '0 1px 6px #d3dce6 inset',
  defaultPadding: '24px',
  paddingSmall: '16px',
  paddingExtraSmall: '8px',
  paddingLarge: '32px',
  paddingExtraLarge: '40px',
  paddingHuge: '56px',
  paddingExtraHuge: '72px',
  paddingMassive: '120px',
  baseMargin: '24px',
  defaultMargin: '24px',
  marginSmall: '16px',
  marginExtraSmall: '8px',
  marginLarge: '32px',
  marginExtraLarge: '40px',
  marginHuge: '56px',
  marginExtraHuge: '72px',
  marginMassive: '120px',
  defaultTransitionTime: '0.3s',
  transitionTimeShort: '0.15s',
  bouncyTransitionCurve: 'cubic-bezier(0.44, 0.11, 0.07, 1.29)',
  defaultTransition: 'all 0.3s ease-in-out',
  transitionShort: 'all 0.15s ease-in-out',
  maxWidthLarge: '1200px',
  maxWidthMedium: '400px',
  screenXs: 'only screen and (max-width: 320px)',
  screenS: 'only screen and (max-width: 375px)',
  screenM: 'only screen and (max-width: 425px)',
  screenL: 'only screen and (max-width: 768px)',
  screenXl: 'only screen and (max-width: 1024px)',
  screenHuge: 'only screen and (min-width: 1024px)',
  phoneSLandscape: 'only screen and (max-width: 375px) and (orientation: landscape)',
  phoneSPortrait: 'only screen and (max-width: 320px) and (orientation: portrait)',
  phoneLandscape: 'only screen and (max-width: 768px) and (orientation: landscape)',
  phonePortrait: 'only screen and (max-width: 425px) and (orientation: portrait)',
  tabletLandscape: 'only screen and (max-width: 1024px) and (orientation: landscape)',
  tabletPortrait: 'only screen and (max-width: 768px) and (orientation: portrait)',
  desktop: 'only screen and (min-width: 1024px) and (orientation: landscape)',
  greaterThanMaximumWidth: 'only screen and (min-width: 1200px)',
  greaterThanMinimumWidth: 'only screen and (min-width: 1024px)',
};

"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const tinycolor2_1 = __importDefault(require("tinycolor2"));
function lighten(color, amount) {
    return tinycolor2_1.default(color)
        .lighten(amount)
        .toString();
}
module.exports.lighten = lighten;
function fade(color, amount) {
    return tinycolor2_1.default(color)
        .setAlpha(amount / 100)
        .toString();
}
module.exports.fade = fade;
function darken(color, amount) {
    return tinycolor2_1.default(color)
        .darken(amount)
        .toString();
}
module.exports.darken = darken;
